import * as CardCrawl from "@ravalmatic/cardcrawl-engine";

import { Utils } from "../../utils/Utils";
import { ButtonWithText } from "../../utils/ButtonWithText";
import { GameVars } from "../../GameVars";
import { GameManager } from "../../GameManager";
import { AudioManager } from "../../AudioManager";

export class ShopCardContainer extends Phaser.GameObjects.Container {

    public specialCardData: CardCrawl.SpecialCard;

    private buyButton: ButtonWithText;
    private i: number;

    constructor(scene: Phaser.Scene, specialCardData: CardCrawl.SpecialCard, i: number, lastUnlockedCardIndex: number) {
        
        super(scene);

        this.specialCardData = specialCardData;
        this.i = i;

        const cardContaner = new Phaser.GameObjects.Container(scene);
        this.add(cardContaner);

        const cardImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", this.specialCardData.type);
        cardContaner.add(cardImg);

        const animatedFrame = new Phaser.GameObjects.Sprite(scene, 0, 0, "texture_atlas_2", "foil_fx_01");
        animatedFrame.alpha = .6;
        animatedFrame.play({key: "foil_fx"});
        scene.add.existing(animatedFrame);
        cardContaner.add(animatedFrame);

        const cardNameLabel = new Phaser.GameObjects.Text(scene, 0, 91, Utils.getCardNameStr(this.specialCardData.type, null), {fontFamily: "AlmendraBold", color: "#FFFFFF", fontSize: "25px"});
        cardNameLabel.setOrigin(.5);

        if (cardNameLabel.width > 130) {
            cardNameLabel.setScale(130 / cardNameLabel.width);
        }

        cardContaner.add(cardNameLabel);

        const background = new Phaser.GameObjects.Image(scene, 315, -35, "texture_atlas_1", "card_description_background");
        this.add(background);

        const descriptionStr = Utils.getSpecialCardDescription(this.specialCardData.type);

        const descriptionLabel = new Phaser.GameObjects.Text(scene, background.x, background.y - 3, descriptionStr, {fontFamily: "Oswald_ExtraLight", fontSize: 28, color: "#5f2a01", align: "center"});
        descriptionLabel.setOrigin(.5);
        descriptionLabel.setWordWrapWidth(370);
        this.add(descriptionLabel);

        const idBox = new Phaser.GameObjects.Image(scene, -160, 0, "texture_atlas_1", "xp_level_box");
        this.add(idBox);

        const idLabel = new Phaser.GameObjects.Text(scene,  -160, idBox.y - 8, (this.i + 1).toString(), {fontFamily: "AlmendraBold", color: "#663227", fontSize: "50px"});
        idLabel.setOrigin(.5);
        this.add(idLabel);

        const cardPriceLabel = new Phaser.GameObjects.Text(scene, 28, -4, GameVars.formatNumber(this.specialCardData.price), {fontFamily: "AlmendraBold", color: "#663227", fontSize: "36px"});
        cardPriceLabel.setOrigin(1, .5);
        const unlockButtonImage = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "button_unlock");

        this.buyButton = new ButtonWithText(scene, unlockButtonImage, cardPriceLabel, this.onClickUnlock, this);
        this.buyButton.visible = false;
        this.buyButton.x = background.x;
        this.buyButton.y = background.y + 110;
        this.add(this.buyButton);

        if (this.specialCardData.price > GameVars.gameData.gold) {
            this.buyButton.disable();
        }

        const coinIcon = new Phaser.GameObjects.Image(scene, 45, -2, "texture_atlas_1", "coin");
        coinIcon.setScale(.85);
        this.buyButton.add(coinIcon);

        if (i >= lastUnlockedCardIndex && lastUnlockedCardIndex !== 0) {

            idBox.setScale(.75);
            idLabel.setScale(.75);

            animatedFrame.visible = false;

            if (i === lastUnlockedCardIndex) {

                this.scene.tweens.add({
                    targets: cardContaner,
                    scaleX: 1.05,
                    scaleY: 1.05,
                    duration: 1000,
                    yoyo: true,
                    repeat: -1
                });

                const lock = new Phaser.GameObjects.Image(scene, 155, 118, "texture_atlas_1", "lock_divider");
                lock.visible = false;
                this.add(lock);
    
                if (GameVars.specialCardJustUnlocked) {
    
                    this.scene.time.delayedCall(600, () => {
                        this.buyButton.visible = true;
                        lock.visible = true;
                    }, null, this);
    
                } else {

                    this.buyButton.visible = true;
                    lock.visible = true;
                }

            } else {

                cardImg.alpha = .5;
                cardNameLabel.alpha = .5;
            }
        }
    }

    private onClickUnlock(): void {

        GameManager.unlockSpecialCard(this.specialCardData.type);

        AudioManager.playSound("equip_treasure");
        AudioManager.playSound("special_used");
    }
}
